var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemDocumentThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 362,
    viewBox: "0 0 543 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3854_20842)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 543,
    height: 362,
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.125 275.584C533.136 276.99 537.989 278.394 543 279.799V375.673H0V266.921C26.4615 267.156 52.6086 269.262 75.7825 273.712C83.9241 275.232 91.9092 276.756 99.7375 278.159C148.902 286.939 194.465 292.44 245.665 286.822C254.277 285.888 263.202 284.715 272.283 283.078C326.302 273.36 382.668 259.431 442.009 260.717C475.203 261.42 501.821 268.328 528.125 275.584Z",
    fill: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.125 275.583C532.98 274.41 537.833 273.359 543 272.538V397.327H0V298.526C0.00105846 298.526 0.00211692 298.526 0.00317538 298.525C12.8592 293.572 28.6938 294.939 42.3151 291.89C73.5237 284.904 103.742 273.591 136.092 271.681C171.282 269.603 203.761 274.886 237.377 283.686C299.558 299.966 363.349 315.702 428.859 304.965C465.811 298.878 493.993 283.894 528.127 275.583H528.125Z",
    fill: "#DAEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.581 321.236C415.392 310.818 477.552 295.834 543 296.068V397.327H0V288.811C20.8252 287.054 41.9615 286.82 63.2556 287.874C93.4746 289.397 123.694 293.375 152.66 298.76C230.165 313.158 273.692 335.402 355.582 321.235L355.581 321.236Z",
    fill: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.369 328.797C484.831 329.241 513.543 332.934 543 341.608V397.328H0V321.005C46.7204 318.552 89.8759 323.438 134.234 335.551C184.905 349.388 238.132 360.218 291.067 350.032C347.608 339.151 401.525 327.943 456.367 328.798L456.369 328.797Z",
    fill: "#B1D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.882 341.609C514.034 337.979 527.813 335.053 543 333.647V397.328H0V353.898C0 353.898 0.00317538 353.898 0.00423384 353.898C27.7454 348.562 54.4228 338.746 82.4317 334.904C137.95 327.288 188.797 345.722 241.594 357.294C282.147 365.956 325.205 372.982 368.42 371.692C381.258 371.343 394.097 370.289 406.936 368.297C428.387 364.905 447.019 358.934 465.494 352.847C477.237 348.983 488.824 345.005 500.881 341.609H500.882Z",
    fill: "#9BC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.839 106C216.588 106 208.77 114.528 208.77 124.43V237.57C208.77 247.473 216.588 256 226.839 256H316.161C326.412 256 334.23 247.473 334.23 237.57V125.005C334.23 114.509 325.722 106 315.226 106H226.839Z",
    fill: "#8FBFFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 106,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0D6DFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 124,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0D6DFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 142,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0D6DFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 160,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0D6DFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 178,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0D6DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3854_20842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 543,
    height: 362,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemDocumentThumbnail);
export default __webpack_public_path__ + "static/media/item_document_thumbnail.c4698a82efb27013dec73e6746972b17.svg";
export { ForwardRef as ReactComponent };